import { render, staticRenderFns } from "./SharingContainer.vue?vue&type=template&id=351c9b4a&scoped=true&"
import script from "./SharingContainer.vue?vue&type=script&lang=js&"
export * from "./SharingContainer.vue?vue&type=script&lang=js&"
import style0 from "./SharingContainer.vue?vue&type=style&index=0&id=351c9b4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351c9b4a",
  null
  
)

export default component.exports